import PropertyLeaseDetailsContainer from 'app/sm/property_lease_details/property_lease_details_container'

export default PropertyLeaseDetailsContainer
